import React from "react";

const ConnectionCustomServiceConfiguratorSelectQuestion = ({
  label,
  unitOfMeasurement,
  symbol,
  options,
  onChange,
  value,
  disabled = false,
  input_type
}) => {

  if (!options?.length) {
    return null;
  }

  return (
    <div className="flex space-x-4">
      {!!label && <div className="flex items-center w-1/3">{label}</div>}
      <div className="flex w-96 my-2">
        <div className="flex justify-center items-center w-3/12 h-full bg-gray-100 border">
          {symbol}
        </div>
        <select
          className="text-black-500 disabled:text-black-300 border border-gray-200 border-l-0 border-r-0 shadow-sm focus:ring-am-500 focus:border-black-500 block w-5/12 sm:text-sm disabled:opacity-50 py-2"
          value={value}
          onChange={(e) => ['select', 'multi_select'].includes(input_type) ?
            onChange(e.target.value) : onChange(e)}
          disabled={disabled}
        >
          <option value=""></option>
          {options.map(({name, value, id}, idx) => (
            <option key={idx} value={input_type==='select'?id:value}>
              {name}
            </option>
          ))}
        </select>
        <div className="flex justify-center items-center w-3/12 h-full bg-gray-100 border">
          {unitOfMeasurement}
        </div>
      </div>
    </div>
  );
};

export default ConnectionCustomServiceConfiguratorSelectQuestion;
